import React from "react";
import { Row, Col, Button } from "antd";
import "../../components/EmployeCard/index.css";
export default function RmxDashboard({
  inputText,
  inputTitle,
  backgroundRmxImage,
  ...props
}) {
  return (
    <Row>
      <Col
        xl={24}
        lg={24}
        md={24}
        xs={24}
        sm={24}
        style={{
          backgroundImage: `url(${backgroundRmxImage})`,
          marginBottom: "30px",
          height: "250px",
          backgroundPosition: "top center",
          objectFit: "cover",
          backgroundSize: "cover",
        }}
      >
        <Row justify="center" style={{ marginTop: '3.8%' }}>
          <Col xl={24} lg={24} md={24} xs={24} sm={24}>
            {/* <Row justify="end" align="bottom">
              <Col xl={5} className="rmx-btn">
                <Button
                  style={{
                    backgroundColor: "#009688",
                    color: "#fff",
                    border: "none",
                    fontSize: "0.9rem",
                  }}
                >
                  REQUEST A QUOTE
                </Button>
              </Col>
            </Row> */}
            <Col>
              <h3 className="rmx-heading1">SEARCH</h3>
            </Col>
          </Col>
          <Col
            xl={13}
            lg={13}
            md={13}
            xs={24}
            sm={24}
            className="rmx-background"
          >
            <h2 className="rmx-heading2">MANUFACTURING PLANTS</h2>
          </Col>
          <Col xl={24} lg={24} md={24} xs={24} sm={24}>
            <span className="rmx-heading1">CLOSEST TO YOU</span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
